import React from 'react';
import * as S from './RightBlock.styles';

const ThankYouFareBlock = ({contactInfo, navigateToMyTrips}) => {
  const {email, mobile} = contactInfo;
  return (
    <S.ThankRightOuterWrap>
      <S.ThankYouRightInnerWrap>
        <S.ManagerBkngWrap>
          <S.ManageBkgHeadTex>Manage Bookings</S.ManageBkgHeadTex>
          <S.ManageBkngSubText>Modify or cancel your bookings from the <span>‘My Bookings’</span> section of the under account settings.   </S.ManageBkngSubText>
          <S.ManagerMyTripText onClick={() => navigateToMyTrips(true)}>Go To My Booking</S.ManagerMyTripText>
        </S.ManagerBkngWrap>
        
        <S.ContactUsWrap>
          <S.ManageBkgHeadTex>Contact Us</S.ManageBkgHeadTex>
          <S.ContactInfoWrap>
            <S.ContantInfoText>{email}</S.ContantInfoText>
          </S.ContactInfoWrap>
          <S.ContactInfoWrap>
            <S.ContantInfoText>{mobile}</S.ContantInfoText>
          </S.ContactInfoWrap>
        </S.ContactUsWrap>
      </S.ThankYouRightInnerWrap>
    </S.ThankRightOuterWrap>
  );
};

export default ThankYouFareBlock;
